/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = require('./Switch');



//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-switch/es/index.js
// module id = 1216
// module chunks = 0